import React from 'react';
import Skeleton from 'react-loading-skeleton';
import styles from './expiring.module.css';

const dayLabel = (days_left) => {
  if (days_left <= 0) return 'Expires today';
  if (days_left === 1) return '1 day left';
  return `${days_left} days left`;
};

const ExpiringSkeleton = () => (
  <div className={styles.list}>
    {[1, 2, 3].map((i) => (
      <div key={i} className={styles.row}>
        <div>
          <Skeleton width={140} height={14} />
          <Skeleton width={90} height={12} style={{ marginTop: 6 }} />
        </div>
        <Skeleton width={60} height={20} borderRadius={20} />
      </div>
    ))}
  </div>
);

export const ExpiringSubscriptions = ({ items = [], loading = false, onView = () => {} }) => {
  return (
    <div className={styles.wrapper}>
      <div className={styles.header}>
        <span className={styles.title}>Expiring subscriptions</span>
        {!loading && items.length > 0 && <span className={styles.badge}>{items.length}</span>}
      </div>

      {loading ? (
        <ExpiringSkeleton />
      ) : items.length === 0 ? (
        <div className={styles.empty}>
          <p className={styles.emptyTitle}>Nothing expiring soon</p>
          <p className={styles.emptyBody}>
            No client subscriptions are due to renew in the next 7 days.
          </p>
        </div>
      ) : (
        <div className={styles.list}>
          {items.map((item) => (
            <button key={item.id} className={styles.row} onClick={() => onView(item)}>
              <div className={styles.rowMain}>
                <span className={styles.client}>{item.client_name}</span>
                <span className={styles.plan}>
                  {[item.plan, item.cost_label, item.expires_label].filter(Boolean).join(' · ')}
                </span>
              </div>
              <span
                className={`${styles.daysPill} ${
                  item.days_left <= 2 ? styles.urgent : styles.soon
                }`}
              >
                {dayLabel(item.days_left)}
              </span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
};
